import { render, staticRenderFns } from "./Gathering.vue?vue&type=template&id=cbf661de"
import script from "./Gathering.vue?vue&type=script&lang=js"
export * from "./Gathering.vue?vue&type=script&lang=js"
import style0 from "./Gathering.vue?vue&type=style&index=0&id=cbf661de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports